// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__asn_P","inline":"Card_inline__WyW5d","bed":"Card_bed__hWgzx","lenkeBaseOverride":"Card_lenkeBaseOverride___PsiO"};